const eatWhitespace = ({ ctx }) => {
    const nl = [];
    while (ctx.char != null && [' ', '\t', '\r', '\n', '\b'].includes(ctx.char)) {
        if (ctx.char === '\n')
            nl.push({ type: 'nl', line: ctx.line, column: ctx.column, position: ctx.position });
        ctx.advance();
    }
    return nl;
};
const risTag = ({ ctx }) => {
    var _a, _b;
    if (ctx.char == null)
        return;
    const line = ctx.line;
    const column = ctx.column;
    const startPosition = ctx.position;
    // we get characters until whitespace
    let name = "";
    let whiteSpaceAfterTag = "";
    while ((_a = ctx.char) === null || _a === void 0 ? void 0 : _a.match(/[A-Za-z0-9]/)) {
        name += ctx.char;
        ctx.advance();
    }
    if (!name) {
        const error = `Expected ris tag ${ctx.line}:${ctx.column}`;
        ctx.advance();
        throw new Error(error);
    }
    while ((_b = ctx.char) === null || _b === void 0 ? void 0 : _b.match(/\s/)) {
        whiteSpaceAfterTag += ctx.char;
        ctx.advance();
    }
    if (ctx.char !== "-") {
        throw new Error(`Expecting dash after tag name definition ${ctx.line}:${ctx.column}`);
    }
    else {
        ctx.advance();
    }
    if (ctx.peek(1) === ' ') // TODO: warn if missing space after dash
        ctx.advance();
    return { name, line, column, startPosition, endPosition: ctx.position };
};
const risFieldValue = ({ ctx }) => {
    const line = ctx.line;
    const column = ctx.column;
    const startPosition = ctx.position;
    if (ctx.char == null)
        return { value: "", line, column, startPosition, endPosition: ctx.position };
    let fieldValue = "";
    do {
        while (!ctx.isEof() && !ctx.char.match(/\n/)) {
            fieldValue += ctx.char;
            ctx.advance();
        }
        if (!ctx.isEof() && ctx.char.match(/\n/)) {
            // quosa uses newlines to terminate fields AND items so we cannot use the lower
            // workaround for multi line fields
            if (ctx.mode === "quosa") {
                ctx.advance();
                return { value: fieldValue, line, column, startPosition, endPosition: ctx.position };
            }
            // ris field value should be terminated by a new line but some products can have multiline
            // field values
            // to determine if the newline is really a terminator we peek into the next line to see if
            // it's tag-like text
            const nextTenChars = ctx.peek(10);
            if (nextTenChars.match(/^\n *[A-Z0-9]{2,6} *-/)) {
                ctx.advance();
                return { value: fieldValue, line, column, startPosition, endPosition: ctx.position };
            }
            fieldValue += ctx.char;
            ctx.advance();
        }
        else {
            if (!ctx.isEof())
                ctx.advance();
        }
    } while (!ctx.isEof());
    return { value: fieldValue, line, column, startPosition, endPosition: ctx.position };
};
const determineIfQuosa = ({ ctx, tag, fieldValue }) => {
    const quosaVnTagPresent = tag.name.trim().toLowerCase() === 'vn';
    const quosaIncValuePresent = fieldValue.value.trim().toLowerCase() === 'quosa inc';
    if (quosaVnTagPresent && quosaIncValuePresent)
        ctx.detectedMode = "quosa";
};
const risTuple = ({ ctx }) => {
    const tag = risTag({ ctx });
    if (!tag)
        return;
    const fieldValue = risFieldValue({ ctx });
    if (ctx.line < 15)
        determineIfQuosa({ ctx, tag, fieldValue });
    return { tag, fieldValue, type: 'ris_tuple' };
};
const advanceToNextNL = ({ ctx }) => {
    while (!ctx.isEof() && ctx.char !== '\n')
        ctx.advance();
    ctx.advance();
};
export const tokenize = ({ ctx, errors }) => {
    var _a;
    let tokens = [];
    let nls = eatWhitespace({ ctx });
    tokens = [...tokens, ...nls];
    // if we encounter this garbage just skip it
    if (ctx.peek(9) === 'Provider:')
        advanceToNextNL({ ctx });
    if (ctx.peek(9) === 'Database:')
        advanceToNextNL({ ctx });
    if (ctx.peek(8) === 'Content:')
        advanceToNextNL({ ctx });
    do {
        try {
            const tuple = risTuple({ ctx });
            if (tuple)
                tokens.push(tuple);
        }
        catch (e) {
            errors.push({
                severity: 'warning',
                message: ((_a = e) === null || _a === void 0 ? void 0 : _a.message) || "",
                line: ctx.line,
                column: ctx.column,
            });
        }
        nls = eatWhitespace({ ctx });
        nls.forEach(nl => tokens.push(nl));
    } while (!ctx.isEof());
    return tokens;
};
